/**
 * React component that is responsible for interpretting one content type block from contentful
 *  and return the appropiate component to render.
 *
 * Copyright (c) 2020 Coursera
 * Author: Kelvin Nguyen
 */
import React from 'react'
import PropTypes from 'prop-types'
import ContentfulImage from './ContentfulImage'
import ContentfulVideo from './ContentfulVideo'
import ContentfulLinkCard from './ContentfulLinkCard'
import ContentfulCtaCard from './ContentfulCtaCard'
import ContentfulCourseCard from './ContentfulCourseCard'

const ContentBlock = ({ content }) => {
  if (!content) return null

  const contentType = content.__typename

  switch (contentType) {
    case 'ContentfulImage':
      return (<ContentfulImage {...content} />)
    case 'ContentfulVideo':
      return (<ContentfulVideo {...content} />)
    case 'ContentfulLinkCard':
      return (<ContentfulLinkCard {...content} />)
    case 'ContentfulCourseCard':
      return (<ContentfulCourseCard {...content} />)
    case 'ContentfulCtaCard':
      return (<ContentfulCtaCard {...content} />)
    default:
      return null
  }
}

ContentBlock.propTypes = {
  content: PropTypes.object,
}

export default ContentBlock
